// extracted by mini-css-extract-plugin
export default {"Confirmation":"ConfirmationDone_Confirmation__0lwpi","Form":"ConfirmationDone_Form__I-Suc","Title":"ConfirmationDone_Title__34cRt","Buttons":"ConfirmationDone_Buttons__tfR5E"};